import cn from "classnames";
import { InputProps } from "./Input.types";
import s from "./Input.module.scss";

export const Input = ({
  variant,
  inputClassName,
  wrapperClassName,
  label,
  error,
  errorMessage,
  ...props
}: InputProps) => {
  const hasError = error || !!errorMessage;

  return (
    <div className={cn(s.wrapper, wrapperClassName)}>
      {label && <span className={s.label}>{label}</span>}
      <input className={cn(s.input, variant && s[variant], { [s.hasError]: hasError }, inputClassName)} {...props} />
      {errorMessage && <span className={s.errorText}>{errorMessage}</span>}
    </div>
  );
};
